import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Panel, Tabs } from '@sketchnote/shared-components';
import { Emoji } from 'emoji-mart';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useFileStore } from 'src/features/files';

import { FileAutomation } from './file-automation';
import { OngoingAutomations } from './Ongoing-automations';
export const AutomationTabs = ({
  isAutomateModalOpen,
  setIsAutomateModalOpen,
}: {
  isAutomateModalOpen: boolean;
  setIsAutomateModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const router = useRouter();
  const currentFile = useFileStore(
    useCallback((s) => s.files[router.query.slug as string], [router.query.slug as string])
  );
  return (
    <>
      <Modal
        isOpen={isAutomateModalOpen}
        onClose={() => {
          setIsAutomateModalOpen(false);
        }}
      >
        <ModalOverlay />
        <ModalContent
          style={{
            maxWidth: '90rem',
            height: '65rem',
            paddingLeft: '28px',
            paddingRight: '28px',
            borderRadius: '8px',
            paddingTop: '28px',
            paddingBottom: '18px',
          }}
        >
          <ModalCloseButton />
          <div className="flex flex-col">
            <span className="flex items-center">
              <div className="h-20 w-20">
                {currentFile?.icon?.type === 'image' ? (
                  <img
                    className="w-20 h-20 object-center object-cover"
                    src={currentFile?.icon?.id}
                  />
                ) : (
                  <div className="m-auto">
                    <Emoji
                      emoji={
                        (currentFile?.icon?.id as any) || {
                          id: 'bulb',
                        }
                      }
                      set="apple"
                      size={20}
                    />
                  </div>
                )}
              </div>
              <p className="font-medium text-2xl pl-8">{currentFile?.name}</p>
            </span>

            <p className="font-regular text-xs mb-24 text-gray-600 pb-20">
              Choose automation details you wish to add to this file
            </p>
          </div>
          <Tabs selected={0} size="small" className="sele border-b mb-10">
            <Panel title="Create">
              <FileAutomation />
            </Panel>
            <Panel title="Ongoing automations">
              <OngoingAutomations />
            </Panel>
          </Tabs>
        </ModalContent>
      </Modal>
    </>
  );
};
